export * from './lib/indent-from-for-prepared-material';
